// removed by extract-text-webpack-plugin
module.exports = {"root":"_3TlWxkq_1ZxdzmFF1zu1Bz","color-default":"_3vSeSsmrDH-wnOJAWalPxp","color-weak":"bB7T887miTxP_YdU7C-e7","size-default":"fHkX_EULpjlGw_GZIrPK_","size-small":"amEKoOA7WO1j7yQUGGXPp","align-default":"_2_CO9mgW-laJ7xoZt_Iczs","align-left":"_3sneD0h5VJrmlr0mj-uAHl","align-center":"m2is14glI2PYjYnDKTFkx","align-right":"VOmgDmGqCR7ep_IVXyZro"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/text.scss
// module id = 1192
// module chunks = 0